"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("@becrop/components/Map/Utils");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
class GisField {
    constructor(config) {
        var _a, _b;
        this.id = config.id;
        this.gfId = config.gfId;
        this.name = config.name;
        this.geodata = config.geodata;
        this.metadata = config.metadata;
        this.crop = config.crop;
        if (config === null || config === void 0 ? void 0 : config.editionData) {
            this.editionData = config === null || config === void 0 ? void 0 : config.editionData;
        }
        else {
            this.editionData = {
                editing: false,
                history: {
                    name: this.name,
                    metadata: this.metadata,
                    crop: this.crop,
                    geodata: this.geodata,
                    management: {
                        id: ((_b = (_a = this.metadata) === null || _a === void 0 ? void 0 : _a.practices) === null || _b === void 0 ? void 0 : _b.management_practices) ? this.metadata.practices.management_practices[0] : -1,
                        name: ''
                    }
                }
            };
        }
    }
    initEdition() {
        console.log(this);
        if (this.editionData) {
            this.editionData.editing = true;
        }
    }
    cancelEdition() {
        console.log('cancel');
        console.log(this);
        if (this.editionData) {
            this.name = this.editionData.history.name;
            this.crop = this.editionData.history.crop;
            this.metadata = this.editionData.history.metadata;
            if (this.editionData.history.management.id && this.metadata && this.metadata.practices) {
                this.metadata.practices.management_practices = [this.editionData.history.management.id];
            }
            this.geodata = this.editionData.history.geodata;
            this.finishEdition();
        }
    }
    finishEdition() {
        if (this.editionData) {
            this.editionData.editing = false;
        }
    }
    setGeodata(g) {
        this.geodata = g;
    }
    calculateAcreage(unit) {
        if (!unit)
            unit = 'acres';
        let extension = (0, Utils_1.getExtension)(this.geodata);
        if (unit.startsWith("h")) {
            return new Acreage_1.default(Math.round((extension / 10000) * 100) / 100, unit);
        }
        else if (unit.startsWith("a")) {
            return new Acreage_1.default(Math.round((extension / 4046.86) * 100) / 100, unit);
        }
        return new Acreage_1.default(-1, unit);
    }
    buildPolygon(w, h) {
        return (0, parcel_1.default)(this.geodata, w, h);
    }
    get stroke() {
        return this.crop.color;
    }
    get fill() {
        return `${this.crop.color}50`;
    }
    updateSize() {
        let extension = (0, Utils_1.getExtension)(this.geodata); // Asumimos que esto da un valor en hectáreas.
        // Si la unidad es hectáreas, usamos el valor tal cual.
        if (this.acreage) {
            if (this.acreage.unit.startsWith('h')) {
                this.acreage.value = Math.round((extension / 10000) * 100) / 100; // Dividir entre 10000 para convertir de m² a hectáreas.
            }
            // Si la unidad es acres, convertimos de hectáreas a acres (1 hectárea = 2.47105 acres).
            else if (this.acreage.unit.startsWith('a')) {
                this.acreage.value = Math.round((extension / 4046.86) * 100) / 100; // Convertir de hectáreas a acres.
            }
        }
    }
}
exports.default = GisField;
